import "./content-app.css";

const ContentApp = ({ children }) => {
  return (
    <div className='content-app container'>
      <div className="row justify-content-center">
        <div className="col-12 col-md-7 col-lg-6">{children}</div>
      </div>
    </div>
  );
};

export default ContentApp;
